<template>
	<Layout>
		<div class="ui form" style="padding: 3em;">
			<div class="grouped fields">
				<label>
					<base-mostrar-markdown
						style="display: inline-block;"
						:contenido="getPregunta.contenido"
					/>
				</label>
				<template v-for="(respuesta, keyRespuesta) in getPregunta.respuestas">
					<div :key="`respuesta-${keyRespuesta}`" style="padding: 1em;">
						<div class="field">
							<div class="ui radio checkbox">
								<input
									:id="`pregunta-${getPregunta.clave}-${keyRespuesta}`"
									type="radio"
									:name="`pregunta-${getPregunta.clave}`"
									:value="respuesta.opcion"
									:checked="respuesta.opcion === seleccionada ? 'checked' : ''"
									@input="seleccionada = $event.target.value"
								/>
								<label
									:key="`respuesta-${keyRespuesta}`"
									:for="`pregunta-${getPregunta.clave}-${keyRespuesta}`"
									style="cursor: pointer;"
								>
									<base-mostrar-markdown
										:agregado="
											`**${String.fromCharCode(65 + keyRespuesta)}** **)** `
										"
										:contenido="respuesta.contenido"
									/>
								</label>
							</div>
						</div>
					</div>
				</template>
			</div>
			<base-button
				style-button="primary"
				class="boldFont right floated"
				@click="siguientePregunta"
				>Siguiente</base-button
			>
		</div>
	</Layout>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Notification from '@utils/notification';
import Layout from '@layouts/examen.vue';
import screenfull from 'screenfull';
export default {
	components: {
		Layout
	},
	data() {
		return {
			seleccionada: ''
		};
	},
	computed: {
		...mapGetters('app', ['getAreaDeConocimiento', 'getSeccion']),
		...mapGetters('examenAspirante', [
			'getPregunta',
			'getExamenAspirante',
			'getPermisoCamara',
			'getPermisoScreen',
			'getLoadingButton'
		]),
		...mapGetters('oidc', ['oidcUser']),
		...mapGetters('configuraciones', [
			'getEnableFullScreen',
			'getEnableCameraRecorder',
			'getEnableScreenRecorder'
		]),
		permisoGrabar() {
			if (this.getEnableCameraRecorder && this.getEnableScreenRecorder) {
				return this.getPermisoCamara && this.getPermisoScreen;
			} else if (this.getEnableCameraRecorder) {
				return this.getPermisoCamara;
			} else if (this.getEnableScreenRecorder) {
				return this.getPermisoScreen;
			}
			return true;
		}
	},
	mounted: function() {
		this.obtenerPregunta({
			ficha: this.oidcUser.username
		});
		this.obtenerIndicador({
			ficha: this.oidcUser.username
		});
		document.elementFromPoint(1, 1).click();
		if (this.getEnableFullScreen) {
			if (screenfull.isEnabled) {
				screenfull.request();
			}
			screenfull.onchange(this.saltarFullScreen);
		}
		window.addEventListener('blur', this.saltar);
	},
	beforeDestroy() {
		window.removeEventListener('blur', this.saltar);
		if (this.getEnableFullScreen)
			screenfull.off('change', this.saltarFullScreen);
	},
	methods: {
		...mapActions('examenAspirante', [
			'contestarPregunta',
			'saltarPregunta',
			'obtenerPregunta',
			'siguiente'
		]),
		...mapActions('indicadores', ['obtenerIndicador']),
		siguientePregunta() {
			if (this.seleccionada) {
				if (!this.permisoGrabar)
					return Notification(
						'error',
						'Favor de dar permiso de grabación para continuar con la realización del examen'
					);
				const opcion = this.seleccionada;
				this.contestarPregunta({
					ficha: this.oidcUser.username,
					opcion: opcion,
					onComplete: (resposeDatos) => {
						this.$nextTick(function() {
							this.seleccionada = '';
						});
						if (
							resposeDatos.data.data.datosGeneralesExamen.preguntaActual === ''
						) {
							this.$router.push('seccion');
						} else {
							this.$gtag.pageview({
								page_path: '/pregunta'
							});
						}
					}
				});
				if (this.getEnableFullScreen)
					if (!screenfull.isFullscreen && screenfull.isEnabled)
						screenfull.request();
			} else {
				Notification('error', '¡Es necesario seleccionar una respuesta!');
			}
		},
		saltarFullScreen() {
			if (!screenfull.isFullscreen) {
				this.saltar();
			}
		},
		saltar() {
			const user = this.oidcUser.username;
			this.saltarPregunta({
				ficha: user,
				onComplete: (response) => {
					if (response.data.data.preguntaActual === '') {
						this.$router.push('seccion');
					} else {
						this.seleccionada = '';
						this.obtenerPregunta({ ficha: user });
						this.$gtag.pageview({
							page_path: '/pregunta'
						});
					}
				},
				onError: (resposeDatos) => {
					this.$router.push('inicio');
				}
			});
			this.lanzarConfirmSalto();
		},
		lanzarConfirmSalto() {
			this.$confirm({
				title: 'Aviso del sistema',
				message:
					'El sistema ha detectado que saliste o intentaste salir de la pantalla del examen. La pregunta en la que estabas ha cambiado por seguridad',
				advertencia:
					'Esto sucederá cada vez que incurras en una acción similar',
				titleOk: 'Aceptar',
				callbackOk: (closeModal) => {
					if (this.getEnableFullScreen && screenfull.isEnabled)
						screenfull.request();
					closeModal();
				},
				callbackCancel: () => {
					if (this.getEnableFullScreen && screenfull.isEnabled)
						screenfull.request();
				}
			});
		}
	}
};
</script>
